// import styles from "./PicModal.module.scss";
import React from "react";
import _ from "lodash";

import Rendition from "../../types/Rendition";
import { Img } from "../Img";
import { CloseXIcon } from "../Icons/CloseX";
import { DownloadIcon } from "../Icons/Download";

export interface PicModalProps {
    renditions: Rendition[];
    onClose: () => void;
    galleryID: number;
    tacID: number;
}

export const PicModal = (props: PicModalProps) => {
    const href = `/api/v2/download/galleries/${props.galleryID}/tacs/${props.tacID}`;

    return (
        <div id="pic-modal" className="pic-modal">
            <div className="pic-modal-menu-bar">
                <div className="close-pic-modal" onClick={props.onClose}>
                    <CloseXIcon onClick={props.onClose} />
                </div>

                <a className="download-img" href={href} download={`${props.tacID}.jpg`}>
                    <DownloadIcon />Download
                </a>
            </div>
            <Img className="pic-modal-img" renditions={props.renditions} size="90vw" />
        </div>
    );
};

export default PicModal;

